module.exports = __webpack_public_path__ + "static/media/tlb-rewards-checkout-icon.2469a7df.svg";